import _ from 'lodash'
import React, { Component } from "react"
import { PropTypes } from "prop-types"
import { bindActionCreators } from 'redux'
import { connect } from "react-redux"
import { Field, reduxForm, propTypes, formValueSelector } from 'redux-form'
import { Row, Col,  FormGroup,InputGroup,Button } from "react-bootstrap"
import { 
	fetchCompletedEvents,setCertificationNumber,uploadEventResults,setEventResultsFile,
	resetEventResultsFile, uploadingResultsFile,setWrongFileType,resetUploadErrorMessage 
} from "../../../redux/actions/action_event"
import ContentWrapper from "../../layout/ContentWrapper"
import  { eventdefaults,forms,videoblue,lightgray,green,warning, blue,field_file } from '../../../utils/constants'
import  { positivenumbers,checkRole } from '../../../utils/helperfunctions'
import userManager from '../../../userManager'

const formName = forms.eventinfo

const selectFileStyle = {
	color:blue,
	minWidth:'200px',
	borderRadius:'0', 
	minHeight:'38px',
	marginRight:'2px',
	border:`1px solid ${lightgray}`,
	backgroundColor:'white' ,
	padding:'8px'
}

class EventResult extends Component 
{
  static propTypes = {
    ...propTypes
  }
  constructor(props)
  {
		super(props)  
		this.state= {
			isAdmin:false,
			roleChecked:false
		} 	
	
		this.handleUploadResults = this.handleUploadResults.bind(this)
		this.setPendingEvents    = this.setPendingEvents.bind(this)
		this.handleEventChange   = this.handleEventChange.bind(this)
		this.eventIsMissingCertNumber = this.eventIsMissingCertNumber.bind(this)
		this.hasFileBeenSelected  = this.hasFileBeenSelected.bind(this)
		this.handleOnFileChange   = this.handleOnFileChange.bind(this)
		this.applyPermission = this.applyPermission.bind(this)
	}
	componentDidMount()
	{
		const { dispatch } = this.props
		dispatch(fetchCompletedEvents())
	}
	handleUploadResults(data)
	{
		const { dispatch } = this.props

		if (data.eventresults)
		{
			const { eventId, eventresults,certificationNumber } = data
			
			dispatch(uploadingResultsFile())
		
			const formData = new FormData()
            formData.append('eventresults', eventresults[0])
      
			dispatch(uploadEventResults(eventId,certificationNumber,formData))
		}
	}
	hasFileBeenSelected()
	{
		const { eventresults } = this.props
		return ( eventresults != undefined && eventresults[0] != undefined)
	}
	handleEventChange(e)
	{
		const { dispatch, setCertificationNumber,pendinguploads,uploadErrorMessage } = this.props
		const eventId = e.target.value
	
		const selectedEvent = _.find(pendinguploads,['id',parseInt(eventId)])
		
		if(selectedEvent !== undefined)
		{
			const { certificationNumber, forceCertificationNumber } = selectedEvent
			dispatch(setCertificationNumber(certificationNumber,forceCertificationNumber))
		}
		else
		{
			dispatch(setCertificationNumber(''))
		}

		if(uploadErrorMessage != undefined && uploadErrorMessage.length > 0)
		{
			dispatch(resetUploadErrorMessage())
		}

	}
	handleOnFileChange(file)
	{
		const { dispatch } = this.props
		const { target } 	 = file
		const fileSelected = target.files.length !== 0 ? true:false
		const filename 		 =  fileSelected == true ? target.files[0].name:''
		const filetype = filename.slice(-4)
		
		dispatch(resetEventResultsFile())
		// make sure the file extension is .xlsm
		if (filetype == 'xlsm')
		{
			dispatch(setEventResultsFile(filename))
		}
		else
		{
			dispatch(setWrongFileType())
		}
	}
	eventIsMissingCertNumber()
	{
		const { eventId,certificationNumber }   = this.props
		console.log('eventIsMissingCertNumber certificationNumber,eventId',typeof(certificationNumber),eventId)
		return (certificationNumber == undefined || certificationNumber == '') && (eventId > 0)
	}
	setPendingEvents()
	{
		const { pendinguploads,oidc } = this.props
		const userEmail = oidc.user.profile.email
    const { isAdmin } = this.state
		const option = pendinguploads.map((pending) => {
			if((pending.directorSSOEmail.toLowerCase() == userEmail.toLowerCase()) || isAdmin)
			{
				return (<option value={`${pending.id}`} key={`${pending.id}`}>{pending.name} {' ('}{pending.startDate} {' - '} {pending.endDate} {')'} </option>)
			}
		})
		return option
	}
	applyPermission()
	{
		const { user } = this.props.oidc
		const { roleChecked } = this.state

		if ((user != null) && (!roleChecked))
		{
			const token = user.access_token
			const _this = this
			_this.setState({ 
				roleChecked:true
			})
			checkRole(token).then(function(response) {
				if (response.data) {
					_this.setState({ 
						isAdmin:response.data,
						roleChecked:true
					})
				}
			})
		}
	}
  render()
	{
		const { 
			handleSubmit,pendinguploads, eventId,uploadingfile,certificationNumber,forceCertificationNumber,
			user,eventResultsFileName,wrongFileUploadType,uploadErrorMessage,successfulUpload 
		} = this.props

		const eventIsMissingCertNumber = this.eventIsMissingCertNumber();
		const uploadError = (uploadErrorMessage != undefined && uploadErrorMessage.length > 0)
		const havePendingUploads = (pendinguploads != undefined && pendinguploads.length > 0) ? true:false
		const disabled = (uploadingfile || (eventId == '-1' || eventId == 0) || eventIsMissingCertNumber || !this.hasFileBeenSelected() || wrongFileUploadType || uploadError)
		const savingdata = false
		const eventResultsSelected = ((eventResultsFileName == undefined) || (eventResultsFileName.length == 0)) ? false:true
		const fileMessage = eventResultsSelected == true ? eventResultsFileName:'No file selected'
		const fileMessageColor = eventResultsSelected  == true ? green:warning

		//console.log('Upload render uploadErrorMessage',uploadErrorMessage)

		if (user == null) 
    {
      userManager.signinRedirect()
		}
		this.applyPermission()
		return (
			<ContentWrapper>
					<div className="content-heading">Upload Event Results</div>
					<form id='resultupload' encType="multipart/form-data" onSubmit={handleSubmit(this.handleUploadResults)} className="form-horizontal" sm={12} style={{ padding:'0',margin:'0' }} >
					{
						!havePendingUploads && (<h4 style={{ color:videoblue }}><i className="fa fa-info-circle" aria-hidden="true"  />&nbsp;&nbsp;You do not have any pending event results uploads</h4>)
					}
					{
						havePendingUploads && 
						(<Row>
							<Col xs={12} md={12} lg={12}>
								<div className="stacked-filter-panel" xs={12}>
									<FormGroup controlId="searchby" className="searchby-filter">
										<InputGroup>
											<Field name='eventId' 
												component="select" 
												disabled={uploadingfile}
												onChange={this.handleEventChange}
												style={{ minWidth:'310px',maxHeight:'40px' }}
												value={eventId}
											>
												<option value='-1'>{' '}&nbsp;Select Event...</option> 
												{
													pendinguploads != undefined && this.setPendingEvents()
												}
											</Field>	
											{ 
												(forceCertificationNumber)  && 
												(<Field name='certificationNumber' 
												type="text"
												component='input' 
												disabled={uploadingfile}
												placeholder='  Enter Event Cert. Number...'
												style={{ minWidth:'180px',maxHeight:'40px',paddingLeft:'5px' }}
												value={certificationNumber}
												onKeyPress={positivenumbers}
												/>)
											}	
											<label  style={selectFileStyle} disabled={savingdata}>
												<i className="fa fa-file-excel-o" aria-hidden="true" />&nbsp;{' '}Select Event Results (.xlsm) {' '}
												<Field type='file' component={field_file} accept=".xlsm" name='eventresults' onChange={this.handleOnFileChange} />						
											</label>
											<label style={{ minWidth:'340px',color:fileMessageColor }}>{fileMessage}</label>
											
										</InputGroup>
										</FormGroup>
									
								</div>
								{ 
									this.eventIsMissingCertNumber() && 
									(
										<div style={{ marginTop:'-20px', marginBottom:'10px' }}>
											<span style={{ color:warning, fontSize:'110%' }}>** Please specify the event certification number to proceed with the results upload</span>
										</div>
									)	
								}
								{
									wrongFileUploadType && 
									(
										<div style={{ marginTop:'-13px', marginBottom:'5px' }}>
											<span style={{ color:warning, fontSize:'110%' }}>** Make sure you select a file of type .xlsm</span>
										</div>
									)
								}
								{
									uploadError && 
									(
										<div style={{ marginTop:'-13px', marginBottom:'5px' }}>
											<span style={{ color:warning, fontSize:'110%' }}>	<i className="fa fa-exclamation-triangle" aria-hidden="true"  />&nbsp;&nbsp; {uploadErrorMessage}</span>
										</div>
									)
								}
								{
									<div>
										<Button type='submit' style={{ color:green, minHeight:'38px',backgroundColor:'white',fontSize:'110%' }} disabled={disabled} onClick={this.handleUploadResults} >
											<i className={uploadingfile == true ? 'fa fa-spinner fa-spin':"fa fa-upload"} aria-hidden="true"  />&nbsp;&nbsp; Upload Event Results
										</Button>
									</div>
								}
								{
									successfulUpload && 
									(
										<div style={{ marginTop:'8px' }}>
											<span style={{ color:green, fontSize:'115%' }}>	<i className="fa fa-info-circle" aria-hidden="true"  />&nbsp;&nbsp; Your event results file has been successfully uploaded</span>
										</div>
									)
								}
							</Col>
						</Row>)
					}
				
				</form>
			
			</ContentWrapper>
		)
  }
}
EventResult.propTypes = {
	dispatch:PropTypes.func,
	handleSubmit:PropTypes.func,
	eventresults:PropTypes.object,
	uploadEventResults:PropTypes.func,
	uploadingResultsFile:PropTypes.func,
	resetUploadErrorMessage:PropTypes.func,
	setCertificationNumber:PropTypes.func,
	setWrongFileType:PropTypes.func,
	setEventResultsFile:PropTypes.func,
	resetEventResultsFile:PropTypes.func,
	fetchCompletedEvents:PropTypes.func,
  norecordsfound:PropTypes.bool,
	pendinguploads:PropTypes.array,
	eventId:PropTypes.string,
	uploadingfile:PropTypes.bool,
	certificationNumber:PropTypes.string,
	user:PropTypes.object,
	eventResultsFileName:PropTypes.string,
	wrongFileUploadType:PropTypes.bool,
	forceCertificationNumber:PropTypes.bool,
	uploadErrorMessage:PropTypes.string,
	successfulUpload:PropTypes.bool,
	oidc:PropTypes.object
}
function mapStateToProps(state,ownProps) {
  const formName        =  ownProps.form
  const selector        = formValueSelector(formName)
	const pendinguploads  = selector(state,'pendinguploads')
	const eventId         = selector(state,'eventId')
	const uploadingfile   = selector(state,'uploadingfile')
	const certificationNumber = selector(state,'certificationNumber')
	const eventresults = selector(state,'eventresults')
	const eventResultsFileName = selector(state,'eventResultsFileName')
	const wrongFileUploadType  = selector(state,'wrongFileUploadType')
	const uploadErrorMessage   = selector(state,'uploadErrorMessage')
	const successfulUpload     = selector(state,'successfulUpload')
	const forceCertificationNumber = selector(state,'forceCertificationNumber')

  return {
		pendinguploads,
		eventId,
		uploadingfile,
		certificationNumber,
		uploadEventResults,
		user: state.oidc.user,
		eventresults,
		eventResultsFileName,
		uploadingResultsFile,
		wrongFileUploadType,
		uploadErrorMessage,
		forceCertificationNumber,
		successfulUpload,
		oidc: { ...state.oidc }
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
		fetchCompletedEvents,
		setCertificationNumber,
		setEventResultsFile,
		resetEventResultsFile,
		uploadingResultsFile,
		setWrongFileType,
		resetUploadErrorMessage
    },dispatch)
}
export default reduxForm({
	form:formName,
	initialValues:eventdefaults,
  destroyOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventResult))



// WEBPACK FOOTER //
// ./src/components/pages/EventResult/index.js